import { ReactNode } from 'react';
import { InterpolationValue } from 'styled-components';
import { TelehealthActionsVariations } from '../TelehealthActions';
import {
  ActionCard,
  ActionCardChevRight,
  ActionCardContent,
  ActionDescription,
  ActionFooter,
  ActionIconWrapper,
  ActionPrice,
  ActionPriceSubTitle,
  ActionSubTitle,
  ActionTitle,
} from './TelehealthAction.styles';

export interface Action {
  route: string;
  title: string;
  subTitle?: string;
  description: string;
  price?: number;
  icon: ReactNode;
  iconColour: InterpolationValue;
  iconBackgroundColour: InterpolationValue;
  highlight?: boolean;
}

export interface ActionCardProps extends Action {
  variation: TelehealthActionsVariations;
}

export const TelehealthActionCard = ({
  title,
  subTitle,
  description,
  price,
  icon,
  route,
  variation,
  iconColour,
  highlight,
  iconBackgroundColour,
}: ActionCardProps) => (
  <ActionCard
    link={route}
    flat
    compact
    variation={variation}
    highlight={highlight}
    data-variation={variation}
  >
    <ActionIconWrapper
      variation={variation}
      iconColour={iconColour}
      iconBackgroundColour={iconBackgroundColour}
    >
      {icon}
    </ActionIconWrapper>
    <ActionCardContent>
      <ActionTitle small subTitleInc={!!subTitle}>
        {title}
      </ActionTitle>
      {subTitle && <ActionSubTitle>{subTitle}</ActionSubTitle>}
      <ActionDescription>{description}</ActionDescription>
    </ActionCardContent>
    <ActionFooter>
      {price && (
        <div>
          <ActionPriceSubTitle>From</ActionPriceSubTitle>
          <ActionPrice>${price}</ActionPrice>
        </div>
      )}
      <ActionCardChevRight />
    </ActionFooter>
  </ActionCard>
);
